import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const DigitalSurveysRoutes: Routes = [
  {
    path: "digital-surveys",
    loadComponent: () =>
      import("./digital-surveys/digital-surveys.component").then(
        (m) => m.DigitalSurveysComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./digital-surveys-list/digital-surveys-list.component").then(
            (m) => m.DigitalSurveysListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./digital-surveys-form/digital-surveys-form.component").then(
            (m) => m.DigitalSurveysFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./digital-surveys-form/digital-surveys-form.component").then(
            (m) => m.DigitalSurveysFormComponent,
          ),
      },
      {
        path: "overview/:id",
        loadComponent: () =>
          import("./digital-surveys-overview/digital-surveys-overview.component").then(
            (m) => m.DigitalSurveysOverviewComponent,
          ),
      },
    ],
  },
];
